var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCounter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.365 50.3542C73.9323 50.2963 77.4761 50.9424 80.793 52.2554C84.1099 53.5684 87.1348 55.5225 89.6942 58.0057C92.2536 60.4889 94.2972 63.4523 95.7078 66.7261C97.1184 69.9998 97.8683 73.5195 97.9145 77.0833V81.25",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8029 58.3335C75.7809 58.3335 80.555 60.3089 84.075 63.8252C87.595 67.3416 89.5725 72.1107 89.5725 77.0835V89.5835",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.365 66.229C73.2201 66.3128 75.9353 67.4832 77.9551 69.5009C79.9749 71.5186 81.1466 74.231 81.2305 77.0832V97.9165",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.02399 54.1668L35.3493 20.8335L60.3754 39.5835L53.097 54.1668L59.854 53.4168C61.5859 53.2316 63.2881 52.8327 64.9218 52.2293L67.8624 50.4377C67.9517 50.3909 68.0516 50.368 68.1524 50.3713C68.2532 50.3745 68.3514 50.4038 68.4375 50.4563C68.5236 50.5087 68.5946 50.5825 68.6437 50.6705C68.6927 50.7586 68.7181 50.8578 68.7174 50.9585V65.7085C68.7181 65.8092 68.6927 65.9084 68.6437 65.9965C68.5946 66.0845 68.5236 66.1583 68.4375 66.2107C68.3514 66.2632 68.2532 66.2925 68.1524 66.2957C68.0516 66.299 67.9517 66.2761 67.8624 66.2293C65.8496 65.0376 63.6111 64.276 61.2886 63.9927C58.966 63.7094 56.6099 63.9106 54.3691 64.5835C49.4038 65.9155 44.8466 68.4566 41.1053 71.9793L35.7873 77.0835C35.4404 77.5378 35.0037 77.9161 34.5043 78.1947C34.0049 78.4733 33.4535 78.6463 32.8843 78.7029C32.3151 78.7596 31.7404 78.6987 31.1957 78.5241C30.6511 78.3494 30.1483 78.0647 29.7185 77.6877L3.02399 54.1668Z",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7654 33.4793C55.7233 30.9065 56.2107 28.1826 56.2044 25.4376C56.2086 21.7275 55.3279 18.0698 53.6352 14.7675C51.9425 11.4651 49.4866 8.61312 46.4709 6.44771C43.4552 4.28229 39.9664 2.86577 36.2935 2.31547C32.6206 1.76516 28.8694 2.09691 25.3504 3.28324C21.8314 4.46957 18.646 6.47633 16.058 9.13733C13.47 11.7983 11.5539 15.037 10.4683 18.585C9.38276 22.1331 9.15901 25.8885 9.81561 29.5401C10.4722 33.1918 11.9902 36.6346 14.244 39.5835",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter1);
export default __webpack_public_path__ + "static/media/counter1.76c250b69061abe06ee7bf4cfc7fcf7f.svg";
export { ForwardRef as ReactComponent };